const GMAPS_PROD_KEY = `AIzaSyAOxulEeTVG2U1_N0WopZYXv8-SRqQLIAc`;
const GMAPS_DEV_KEY = `AIzaSyD37vfqXhIgJXqTvRUA08--dQKUX37P6Oo`;

const googleMapsApiKey =
  process.env.NODE_ENV === 'production' ? GMAPS_PROD_KEY : GMAPS_DEV_KEY;
export default googleMapsApiKey;
// Maps
